import {Table, Form, Space, Radio, Badge, Flex, InputNumber, DatePicker, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import ExpenseCheck from './ExpenseCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './expense.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import ClientSelect from '../../system/client/ClientSelect';
import dayjs from 'dayjs';
import UserSelect from '../../system/user/UserSelect';
function ExpenseListAll(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "fy_state": '',     
  });
    useEffect(() => {
        if (props.list) {
            let arr = props.list.slice();
            if(query.fy_state){
              arr = arr.filter((item) => item.fy_state === query.fy_state);
            }      
            if(query.fy_kh_id){
              arr = arr.filter((item) => Number(item.fy_kh_id) === Number(query.fy_kh_id));
            }
            if(query.fy_date){
              arr = arr.filter((item) => dayjs(item.fy_date).format('YYYY-MM-DD') === query.fy_date);
            }
            if(query.fy_uid){
              arr = arr.filter((item) => item.fy_uid === query.fy_uid);
            }
            if(query.fy_id){
              arr = arr.filter((item) => item.key === query.fy_id);
            }
            if(query.fy_amount){
              arr = arr.filter((item) => Number(item.fy_amount) === Number(query.fy_amount));
            }
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.fy_id
            }));
            arr.sort((a, b) => new Date(b.fy_ctime) - new Date(a.fy_ctime));
            setList(arr);
        }
    }, [props.list, props.yh_id, query])
    
    const columns = [    
        {
            title: '付款客户',
            dataIndex: 'fy_kh_name',
            width: '12%',
            key: 'fy_kh_name',         
            render: (text, record) =><ExpenseCheck
                                        type='button'
                                        fy_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        fy_bzd_id={record.fy_bzd_id}
                                        fy_price={record.fy_price}
                                        fy_content={record.fy_content}
                                        fy_date={record.fy_date}
                                        fy_date_end={record.fy_date_end}
                                        fy_bzd_name={record.fy_bzd_name}
                                        fy_bzd_danhao={record.fy_bzd_danhao}
                                        fy_type_id={record.fy_type_id}
                                        fy_type_name={record.fy_type_name}
                                        fy_kh_id={record.fy_kh_id}
                                        fy_kh_name={record.fy_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        fy_num={record.fy_num}
                                        fy_amount={record.fy_amount}
                                        fy_state={record.fy_state}
                                        fy_bm_id={record.fy_bm_id}
                                        fy_bm_name={record.fy_bm_name}
                                        fy_khyhzh_id={record.fy_khyhzh_id}
                                        fy_khyhzh_name={record.fy_khyhzh_name}
                                        fy_image_name={record.fy_image_name}
                                        fy_image_file={record.fy_image_file}
                                        fy_ctime={record.fy_ctime}
                                        fy_uid={record.fy_uid}
                                        yh_qx={props.yh_qx}
                                    />
        },
        {
            title: '付款金额',
            dataIndex: 'fy_amount',
            width: '10%',
            key: 'fy_amount',   
            render: (text, record) => <span style={{color:'#3366cc'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'fy_content',
            key:'fy_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"fy_bzd_danhao",
            key:'fy_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.fy_bzd_name} dsbzd_id={record.fy_bzd_id} dsbzd_danhao={record.fy_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },  
        {
            title: '提交记录',
            dataIndex: 'fy_ctime',
            key:'fy_ctime',
            render:(text,record) => {
                return <span>{record.fy_uname} {record.fy_ctime}</span>
            }
        },    
        {
            title: '状态',
            dataIndex: 'fy_state',
            width: '5%',
            key: 'fy_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_expense_list_all'
                    form={form}
                    initialValues={{                        
                        fy_state: query.fy_state ? query.fy_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            fy_state: values.fy_state ? values.fy_state : '',
                            fy_kh_id: values.fy_kh_id ? values.fy_kh_id : '',
                            fy_date: values.fy_date ? values.fy_date : '',
                            fy_uid: values.fy_uid ? values.fy_uid : '',
                            fy_id: values.fy_id ? values.fy_id : '',
                            fy_name: values.fy_name ? values.fy_name : '',
                        };
                        setQuery(prev => ({ ...prev, ...serializedValues }));
                        localStorage.setItem('jtg-caiwu_expenseList_fy_state', JSON.stringify(serializedValues.fy_state));
                        localStorage.setItem('jtg-caiwu_expenseList_fy_kh_id', JSON.stringify(serializedValues.fy_kh_id));
                        localStorage.setItem('jtg-caiwu_expenseList_fy_date', JSON.stringify(serializedValues.fy_date));
                        localStorage.setItem('jtg-caiwu_expenseList_fy_uid', JSON.stringify(serializedValues.fy_uid));
                        localStorage.setItem('jtg-caiwu_expenseList_fy_id', JSON.stringify(serializedValues.fy_id));
                    }}
                >
                    <Form.Item 
                        name='fy_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    fy_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_expenseList_fy_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Radio value='5' >已结束（未读）</Radio>
                            <Radio value='6' >已结束（已读）</Radio>
                        </Radio.Group>        
                    </Form.Item>    
                    <Form.Item name='fy_amount' wrapperCol={{ offset: 2 }}>
                        <InputNumber
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, fy_amount: value }));
                            }}
                            value={query.fy_amount ? query.fy_amount : undefined}
                            placeholder='费用单金额'
                            name='fy_amount'
                            style={{ width: '120px' }}
                        />
                    </Form.Item> 
                    <ClientSelect                       
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, fy_kh_id: '' })) }}
                        placeholder='费用单客户'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='fy_kh_id'
                        onChange={(khId) => { setQuery(prev => ({ ...prev, fy_kh_id: khId || '' })) }}
                        yh_id={props.yh_id}
                        list={props.commonList?.kf_data || props.commonList?.kh_data || []}
                        wrapperCol={{ span: 18 }}
                    />  
                    <Form.Item name='fy_date'>
                        <DatePicker 
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, fy_date: dayjs(value).format('YYYY-MM-DD') }));
                            }}
                            value={query.fy_date ? dayjs(query.fy_date) : null}
                            allowClear={true}
                            placeholder='费用单日期'
                            name='fy_date'
                        />
                    </Form.Item>          
                    <UserSelect
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, fy_uid: '' })) }}
                        placeholder='操作员'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='fy_uid'
                        onChange={(e) => {setQuery(prev => ({ ...prev, fy_uid: e.yh_id || '' }))}}
                    />
                    <Form.Item name='fy_id' >
                        <Input placeholder='费用单编号' onChange={(e) => {setQuery(prev => ({ ...prev, fy_id: e.target.value || '' }))}} style={{ width: "100px" }} />
                    </Form.Item>
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_expenseList_fy_state', JSON.stringify(''))
                                    setQuery({
                                        "fy_state": '',
                                        fy_kh_id: '',
                                        fy_amount: undefined,
                                        fy_uid: '',
                                        fy_date: '',
                                        fy_id: '',
                                    })
                                    form.setFieldsValue({
                                        fy_name: null,
                                        fy_kh_id: null,
                                        fy_bzd_danhao: null,
                                        fy_uid: null,
                                        fy_date: null,
                                        fy_id: '',
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={{
                    pageSize: 50,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        console.log(page, pageSize);
                    }
                }}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'#3366cc'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无付款数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default ExpenseListAll